import React from 'react';

// Own components
import SEO from '../components/seo';
import Index from '../containers/Index';
import Layout from '../components/Layout/en';

const IndexPage = () => (
  <Layout>
    <SEO title="Welcome" />
    <Index />
  </Layout>
);

export default IndexPage;
